import React, { useState } from 'react';
import { IoMdTrash, IoMdWarning } from 'react-icons/io';
import { Modal as ModalAnt } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { useRouter } from 'next/router';
import { useFormikContext } from 'formik';

import { isBounceWebview, postMessageToRN } from 'legacy/common/utils/webview';
import { WEBVIEW_CLOSE } from 'legacy/common/constants/webview';
import Modal, { ModalType } from 'legacy/common/components/modal/Modal';
import Button, { ButtonType } from 'legacy/common/components/button/Button';

import { useDeleteEvent, useGetEvent } from '../../../hooks';

const DangerZone = ({ eventId, navigateToSeriesSettings }) => {
  const [isSeriesWarningModalOpen, setIsSeriesWarningModalOpen] =
    useState(false);
  const router = useRouter();
  const deleteEventCommand = useDeleteEvent();
  const { data: event } = useGetEvent(eventId);
  const { setFieldValue } = useFormikContext();

  const toggleSeriesWarningModal = () => {
    setIsSeriesWarningModalOpen((prevState) => !prevState);
  };

  const setEventToPrivate = () => {
    setFieldValue('private', true);
    toggleSeriesWarningModal();
  };

  const deleteEvent = () => {
    if (event.seriesId) {
      toggleSeriesWarningModal();
    } else {
      ModalAnt.confirm({
        title: 'Delete event',
        icon: <ExclamationCircleOutlined />,
        content: 'Are you sure you want to delete this event?',
        centered: true,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk() {
          deleteEventCommand.mutate(eventId, {
            onSuccess: () => {
              if (isBounceWebview()) {
                postMessageToRN(WEBVIEW_CLOSE);
              } else {
                router.push('/host');
              }
            }
          });
        }
      });
    }
  };

  return (
    <>
      <div className="mt-6">
        <h3 className="font-semibold text-lg">Danger zone</h3>
        <div className="flex items-center justify-between px-4 py-5 border-1 border-red-700 rounded-lg mt-4 bg-red-50">
          <div className="flex items-center">
            <IoMdTrash size={24} />
            <span className="ml-2 text-base">Delete event</span>
          </div>
          <button
            type="button"
            className="text-base text-red-700 font-bold cursor-pointer"
            onClick={deleteEvent}
          >
            Delete
          </button>
        </div>
      </div>
      <Modal
        visible={isSeriesWarningModalOpen}
        onClose={toggleSeriesWarningModal}
        type={ModalType.SMALL}
        autoHeight
        title="Cannot Delete Events in A Series"
        icon={
          <div className="bg-red-100 flex-1 h-full flex items-center justify-center text-red-800">
            <IoMdWarning size={20} />
          </div>
        }
      >
        <div className="p-4">
          <p className="text-base font-normal text-neutral-600">
            Events in a recurring series cannot be deleted. To hide just this
            event, set it to private instead or change the series to &ldquo;Does
            not repeat&rdquo; to adjust all events.
          </p>
          <div className="flex gap-4 pt-8 pb-4">
            <Button
              type={ButtonType.Primary}
              onClick={navigateToSeriesSettings}
              newRadius
            >
              Update Settings
            </Button>
            <Button
              type={ButtonType.Primary}
              onClick={setEventToPrivate}
              newRadius
            >
              Set to Private
            </Button>
          </div>
          <Button
            type={ButtonType.Inverted}
            onClick={toggleSeriesWarningModal}
            newRadius
          >
            Cancel
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DangerZone;
